module.exports = __webpack_public_path__ + "img/leftthigh-ecto-mesomorph-male.9832e438.svg";